import { API_URL } from '../../app/apiConfig';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers = { 'content-type': 'application/json' };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  return headers;
};

export function fetchLoggedInUserOrders() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/orders/own/`, {
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      const data = await response.json();
      resolve({ data });
    } catch (err) {
      reject(err);
    }
  });
}

export function fetchLoggedInUser() {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/users/own`, {
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      const data = await response.json();
      resolve({ data });
    } catch (err) {
      reject(err);
    }
  });
}

export function updateUser(update) {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await fetch(`${API_URL}/api/users/` + update.id, {
        method: 'PATCH',
        body: JSON.stringify(update),
        headers: getAuthHeaders(),
        credentials: 'include',
      });
      const data = await response.json();
      resolve({ data });
    } catch (err) {
      reject(err);
    }
  });
}


